"use client";

export {
  create as createModal,
  hide as hideModal,
  NiceModalContext,
  show as showModal,
  useModal,
} from "@ebay/nice-modal-react";
